import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import LoadingScreen from "./LoadingScreen";
import "../css/EnquiryList.css"
import { ShimmerTable } from "react-shimmer-effects";

function EnquiryListTable() {

  const navigate = useNavigate()

  const [isSending, setIsSending] = useState(false);
  const [listOfEnquiry, setListOfEnquiry] = useState([]);
  const [stateCompanyCode, setCompanyCode] = useState("");

  const getListOfEnquiries = () => {

    setIsSending(true);

    let current_company_local = localStorage.getItem("current_company");
    let currentCompany;
    if (current_company_local) {
      currentCompany = JSON.parse(localStorage.getItem("current_company"));

      console.log("Home page company value is  ", currentCompany);

      setCompanyCode(currentCompany.company_code);
    }

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/EnquiryList/${currentCompany.company_code}`;

    console.log("api url ", apiUrl);

    axios
      .get(apiUrl)
      .then((res) => {

        setIsSending(false);

        console.log("Enquiry Table response ", res.data);
        setListOfEnquiry(res.data);
      })
      .catch((e) => {
        console.log("the error in Homepage api call " + e);
        setIsSending(false);
      });
  };

  const getBackGroundColor = (statusReceived) => {

    switch (statusReceived) {
      case "Waiting For Accept": return "waiting_for_accept"
      case "Order Confirmed": return "order_confirmed"
      case "Quotation Generated": return "quotation_generated"
      case "DRAFT" : return "draft_bg"
      default: return "waiting_for_accept"
    }


  }

  useEffect(() => {
    console.log("HomePage Machine component >>>>>>> MOunted ");

    getListOfEnquiries();

    return function cleanup() {
      console.log("HomePage Machine component <<<<<<< unmounted ");
    };
  }, []);

  return (
    <div className="Enquiry_list_table_container" >
      {isSending ? (

        <ShimmerTable row={10} />

      ) : (
        <table className="HomePage-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Enquiry Number</th>
              <th>Status</th>
              <th>Reference</th>
              <th>View</th>
              <th>Edit</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            {listOfEnquiry.map((singleItem, index) => {
              return (
                <tr
                  key={index}
                  className={
                    singleItem.type === "Draft"
                      ? "HomePage-draft-row-bg"
                      : "HomePage-accepted-row-bg"
                  }
                >
                  <td>{singleItem.type}</td>
                  <td>{ singleItem.type === "Draft" ? "" : singleItem.enquiry_number}</td>
                  <td className={getBackGroundColor(singleItem.status)}>

                    {singleItem.status}

                  </td>
                  <td>{singleItem.reference}</td>
                  <td>
                    {" "}

                    {/* change viewpath based on */}
                    {
                      (singleItem.status == "Quotation Generated" || singleItem.status == "Order Confirmed") ?

                        <Link
                          className="Enquiry_table_view_button"
                          to="/viewEnquiryAfterQuotationGeneration"
                          state={{
                            enquiryNumber: singleItem.enquiry_number,
                            companyCodeForView: stateCompanyCode,
                            quotationNumber: singleItem.qoutNo,
                            status: singleItem.status
                          }
                          }
                        >
                          View
                        </Link>

                        :

                        <Link
                          className="Enquiry_table_view_button"
                          to={
                            singleItem.type === "Draft" ?
                              "/viewDraft" : "/viewEnquiry"
                          }

                          state={
                            {
                              enquiryNumber: singleItem.enquiry_number,
                              companyCodeForView: stateCompanyCode,
                            }
                          }
                        >
                          View
                        </Link>
                    }


                    {/* svfsv */}
                  </td>
                  <td>
                    {singleItem.type === "Draft" ? (
                      <Link

                        to={
                          "/createEnquiryFromDraft"
                        }

                        state={
                          {
                            enquiryNumber: singleItem.enquiry_number,
                            companyCodeForView: stateCompanyCode,
                          }
                        }
                      >
                        Edit
                      </Link>
                    ) : (
                      ""
                    )}
                  </td>

                  <td>
                    <p>{singleItem.enteredBY}</p>
                  </td>


                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
export default EnquiryListTable;
